module.exports = __webpack_public_path__ + "img/ARS.beaaccce.svg";